import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Warning from "@mui/icons-material/Warning";
import { useWarnings } from "@seabrookstudios/pitch2table";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").Warning} props.warning
 */
const WarningItem = ({ warning }) => {
  return (
    <ListItem>
      <ListItemText primary={warning.title} secondary={warning.description} />
      <Chip icon={<Warning />} label="WARNING" color="warning" size="small" />
    </ListItem>
  );
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").Game} props.game
 */
export const ContractCardForGame = ({ game }) => {
  const warnings = useWarnings(game.id);

  if (warnings.length === 0) {
    return null;
  }

  return (
    <Card elevation={1} square={false}>
      <CardContent>
        <List>
          <ListItem>
            <ListItemText primary="Contract Warnings" />
          </ListItem>
          {warnings.map((warning) => (
            <WarningItem key={warning.title} warning={warning} />
          ))}
        </List>
      </CardContent>
    </Card>
  );
};
